export default [
  {
    name: 'Policy',
    path: '/policy/index',
    component: () => import (`@/views/policy/policy.vue`),
    meta: {
      title: '政策速递'
    }
  }
];
